import { Pipe, PipeTransform } from '@angular/core';
import { AccountService } from '../auth/account.service';
import { PagePermissionsService } from '../auth/page-permissions.service';

@Pipe({
    name: 'hasPermission',
    pure: false,
    standalone: false
})
export class HasPermissionPipe implements PipeTransform {

  constructor(
    private accountService: AccountService,
    private pagePermissions: PagePermissionsService
  ) { }

  transform(permission: string): boolean {
    if (!this.accountService.isAuthenticated()) {
      return false;
    }

    if (!permission) {
      return false;
    }

    try {
      if (permission.includes('.')) {
        const [page, action] = permission.split('.');
        const requiredPerms = this.pagePermissions.getPermissionsFor(page, action);

        if (requiredPerms.length === 0) {
          return true;
        }
        return this.accountService.hasAnyPermission(requiredPerms);
      } else {
        return this.accountService.hasAnyPermission([permission]);
      }
    } catch (error) {
      console.warn('Error checking permission:', error);
      return false;
    }
  }
}
